import plugin from './plugin';

class PluginCountdown2 {
	constructor(element) {
		this.$el = $(element);

		this.options = {
			to: this.$el.data('to'),
			type: this.$el.data('type') || 'full',
		};
		this.countdown();
		this.$el.css('opacity', 1);
	}

	countdown() {
		const units = ['day', 'hour', 'minute', 'second'];
		const t = Math.max(this.options.to - Math.round(Date.now() / 1000), 0);

		const values = [
			Math.floor(t / (60 * 60 * 24)), // days
			Math.floor((t / (60 * 60)) % 24), // hours
			Math.floor((t / 60) % 60), // minutes
			Math.floor(t % 60), // seconds
		];

		if (this.options.type === 'full') {
			for (const i in units) {
				const $item = this.$el.find(`.m-countdown-counter-${units[i]}`);
				$item.children('.item-value').text(values[i]);
				$item.children('.item-label').text(PluginCountdown2.plural(units[i], values[i]));
			}
		} else {
			const result = [];
			for (const i in units) {
				const amount = values[i];
				if (amount > 0) {
					result.push(`${amount} ${PluginCountdown2.plural(units[i], amount)}`);
				}
				if (amount > 5 || result.length >= 2) break;
			}
			this.$el.text(result.join(', '));
		}

		window.setTimeout(() => this.countdown(), 1000);
	}

	static plural(x, y) {
		if (y > 1) {
			x = `${x}s`;
		}
		return x;
	}
}

plugin('PluginCountdown2', PluginCountdown2);
